<template>
    <div>

        <div class="row" id="m_sortable_portlets">
            <div class="kanban__item-list step-1">
                <h2>1. Reminder</h2>
                <div v-for="offer in offers" v-if="offer.reminder_1_level == 0" :class="{ 'reminder-not-active': !offer.isReminder }" class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet" data-portlet="true" id="m_portlet_tools_1">
                    <div class="m-portlet__head pl-0">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <div class="row pt-1 ml-0 mr-0">

                                    <div class="col-8">
                                        <span v-if="offer.client_id == 0 || offer.is_new_client" class="m-badge  m-badge--danger m-badge--wide">NEUKUNDE</span>
                                        <span v-else class="m-badge  m-badge--metal m-badge--wide">STAMM KD</span>
                                        <span v-if="offer.wait == 1 && offer.status_id === 1" class="m-badge m-badge--info m-badge--wide">WAIT</span>
                                        <span v-if="offer.from_id == 2" class="ml-1 m-badge m-badge--danger m-badge--wide">CAPTURE STUDIO</span>
                                        <span v-else class="ml-1  m-badge m-badge--info m-badge--wide">PROFO</span>
                                    </div>
                                    <div class="col-4 text-right">
                                        <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.createdDay }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <div class="m-card-user m-card-user--sm">
                            <div class="m-card-user__pic">
                                <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + offer.classId"><span>{{ offer.className }}</span></div>
                            </div>
                            <div class="m-card-user__details">
                                <span class="m-card-user__name font-weight-bold" v-if="offer.firma != ''" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0">{{ offer.client_id }}</a> {{ offer.firma }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0 && offer.firma == ''">{{ offer.client_id }}</a> {{ offer.name }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.email }}</small></span>
                                <span class="m-card-user__name" v-if="offer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.telefon }}</small></span>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__foot" v-if="offer.isReminder">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span v-if="offer.reminderDays > 3" class="m-badge m-badge--warning m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                                <span v-else class="m-badge m-badge--secondary m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot" v-else-if="offer.reminderDate !== 'null'">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span class="m-badge m-badge--info m-badge--wide">Reminder für {{ offer.reminderDate }} gesetzt</span>

                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.price }} € pro Bild</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <span class="m-badge  m-badge--secondary m-badge--wide">SUMME {{ offer.sum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.anzahlCa }} Bilder</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <button class="btn btn-default js-project-portlet__details-btn" @click="showDetails(offer)">Details ({{ offer.updates.length }})</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-portlet m-portlet--sortable-empty status-1"></div>
            </div>
            <div class="kanban__item-list step-2">
                <h2>2. Reminder</h2>
                <div v-for="offer in offers" v-if="offer.reminder_1_level == 1" :class="{ 'reminder-not-active': !offer.isReminder }" class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet" data-portlet="true" id="m_portlet_tools_2">
                    <div class="m-portlet__head pl-0">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <div class="row pt-1 ml-0 mr-0">

                                    <div class="col-8">
                                        <span v-if="offer.client_id == 0 || offer.is_new_client" class="m-badge  m-badge--danger m-badge--wide">NEUKUNDE</span>
                                        <span v-else class="m-badge  m-badge--metal m-badge--wide">STAMM KD</span>
                                        <span v-if="offer.wait == 1" class="m-badge m-badge--info m-badge--wide">WAIT</span>
                                        <span v-if="offer.from_id == 2" class="ml-1 m-badge m-badge--danger m-badge--wide">CAPTURE STUDIO</span>
                                        <span v-else class="ml-1  m-badge m-badge--info m-badge--wide">PROFO</span>
                                    </div>
                                    <div class="col-4 text-right">
                                        <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.createdDay }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <div class="m-card-user m-card-user--sm">
                            <div class="m-card-user__pic">
                                <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + offer.classId"><span>{{ offer.className }}</span></div>
                            </div>
                            <div class="m-card-user__details">
                                <span class="m-card-user__name font-weight-bold" v-if="offer.firma != ''" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0">{{ offer.client_id }}</a> {{ offer.firma }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0 && offer.firma == ''">{{ offer.client_id }}</a> {{ offer.name }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.email }}</small></span>
                                <span class="m-card-user__name" v-if="offer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.telefon }}</small></span>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__foot" v-if="offer.isReminder">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span v-if="offer.reminderDays > 3" class="m-badge m-badge--warning m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                                <span v-else class="m-badge m-badge--secondary m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot" v-else-if="offer.reminderDate !== 'null'">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span class="m-badge m-badge--info m-badge--wide">Reminder für {{ offer.reminderDate }} gesetzt</span>

                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.price }} € pro Bild</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <span class="m-badge  m-badge--secondary m-badge--wide">SUMME {{ offer.sum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.anzahlCa }} Bilder</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <button class="btn btn-default js-project-portlet__details-btn" @click="showDetails(offer)">Details ({{ offer.updates.length }})</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-portlet m-portlet--sortable-empty status-2"></div>

            </div>
            <div class="kanban__item-list step-3">
                <h2>3. Reminder</h2>
                <div v-for="offer in offers" v-if="offer.reminder_1_level == 2" :class="{ 'reminder-not-active': !offer.isReminder }" class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet" data-portlet="true" id="m_portlet_tools_3">
                    <div class="m-portlet__head pl-0">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <div class="row pt-1 ml-0 mr-0">

                                    <div class="col-8">
                                        <span v-if="offer.client_id == 0 || offer.is_new_client" class="m-badge  m-badge--danger m-badge--wide">NEUKUNDE</span>
                                        <span v-else class="m-badge  m-badge--metal m-badge--wide">STAMM KD</span>
                                        <span v-if="offer.wait == 1" class="m-badge m-badge--info m-badge--wide">WAIT</span>
                                        <span v-if="offer.from_id == 2" class="ml-1 m-badge m-badge--danger m-badge--wide">CAPTURE STUDIO</span>
                                        <span v-else class="ml-1  m-badge m-badge--info m-badge--wide">PROFO</span>
                                    </div>
                                    <div class="col-4 text-right">
                                        <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.createdDay }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <div class="m-card-user m-card-user--sm">
                            <div class="m-card-user__pic">
                                <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + offer.classId"><span>{{ offer.className }}</span></div>
                            </div>
                            <div class="m-card-user__details">
                                <span class="m-card-user__name font-weight-bold" v-if="offer.firma != ''" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0">{{ offer.client_id }}</a> {{ offer.firma }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0 && offer.firma == ''">{{ offer.client_id }}</a> {{ offer.name }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.email }}</small></span>
                                <span class="m-card-user__name" v-if="offer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.telefon }}</small></span>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__foot" v-if="offer.isReminder">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span v-if="offer.reminderDays > 3" class="m-badge m-badge--warning m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                                <span v-else class="m-badge m-badge--secondary m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot" v-else-if="offer.reminderDate !== 'null'">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span class="m-badge m-badge--info m-badge--wide">Reminder für {{ offer.reminderDate }} gesetzt</span>

                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.price }} € pro Bild</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <span class="m-badge  m-badge--secondary m-badge--wide">SUMME {{ offer.sum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.anzahlCa }} Bilder</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <button class="btn btn-default js-project-portlet__details-btn" @click="showDetails(offer)">Details ({{ offer.updates.length }})</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-portlet m-portlet--sortable-empty status-3"></div>
            </div>
            <div class="kanban__item-list step-4">
                <h2>4. Reminder</h2>
                <div v-for="offer in offers" v-if="offer.reminder_1_level == 3" :class="{ 'reminder-not-active': !offer.isReminder }" class="m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet" data-portlet="true" id="m_portlet_tools_4">
                    <div class="m-portlet__head pl-0">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <div class="row pt-1 ml-0 mr-0">

                                    <div class="col-8">
                                        <span v-if="offer.client_id == 0 || offer.is_new_client" class="m-badge  m-badge--danger m-badge--wide">NEUKUNDE</span>
                                        <span v-else class="m-badge  m-badge--metal m-badge--wide">STAMM KD</span>
                                        <span v-if="offer.wait == 1" class="m-badge m-badge--info m-badge--wide">WAIT</span>
                                        <span v-if="offer.from_id == 2" class="ml-1 m-badge m-badge--danger m-badge--wide">CAPTURE STUDIO</span>
                                        <span v-else class="ml-1  m-badge m-badge--info m-badge--wide">PROFO</span>
                                    </div>
                                    <div class="col-4 text-right">
                                        <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.createdDay }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <div class="m-card-user m-card-user--sm">
                            <div class="m-card-user__pic">
                                <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + offer.classId"><span>{{ offer.className }}</span></div>
                            </div>
                            <div class="m-card-user__details">
                                <span class="m-card-user__name font-weight-bold" v-if="offer.firma != ''" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0">{{ offer.client_id }}</a> {{ offer.firma }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><a class="text-primary" :href="'kunde-' + offer.client_id" v-if="offer.client_id > 0 && offer.firma == ''">{{ offer.client_id }}</a> {{ offer.name }}</span>
                                <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.email }}</small></span>
                                <span class="m-card-user__name" v-if="offer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.telefon }}</small></span>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__foot" v-if="offer.isReminder">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span v-if="offer.reminderDays > 3" class="m-badge m-badge--warning m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                                <span v-else class="m-badge m-badge--secondary m-badge--wide">Reminder für {{ offer.reminderName }} seit {{ offer.reminderDays }} Tagen</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot" v-else-if="offer.reminderDate !== 'null'">
                        <div class="row">
                            <div class="col-12 align-items-right text-left">
                                <span class="m-badge m-badge--info m-badge--wide">Reminder für {{ offer.reminderDate }} gesetzt</span>

                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.price }} € pro Bild</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <span class="m-badge  m-badge--secondary m-badge--wide">SUMME {{ offer.sum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="row">
                            <div class="col-6 align-items-right text-left">
                                <span class="m-badge  m-badge--secondary m-badge--wide">{{ offer.anzahlCa }} Bilder</span>
                            </div>
                            <div class="col-6 align-items-right text-right">
                                <button class="btn btn-default js-project-portlet__details-btn" @click="showDetails(offer)">Details ({{ offer.updates.length }})</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-portlet m-portlet--sortable-empty status-4"></div>
            </div>
            <div class="kanban__item-list step-5">
                <h2>Abschuss Liste</h2>
                <div class="m-portlet m-portlet--sortable-empty status-5"></div>
            </div>
        </div>

        <offer-details :detail-offer="detailOffer" :user="user" :reminder-type-arr="reminderTypeArr" :managers="managers"></offer-details>

    </div>
</template>


<script>
import ProjectStats from "./client/ProjectStats";
import OfferDetails from "./offer/OfferDetails";

export default {
    name: 'offer-reminder-site',
    components: {
        OfferDetails,
        ProjectStats
    },
    props: {
        offers: Array,
        reminderTypeArr: Array,
        managers: Array,
        user: Object,
    },
    data() {
        return {
            detailOffer: null,
        }
    },
    created: function () {

    },
    methods: {
        showDetails(offer) {
            this.detailOffer = offer;
        },
    }
}
</script>
